module.exports = __webpack_public_path__ + "static/img/banner08.f452a1c5.png";